import type { ReactElement } from "react";

import { Tooltip } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import MenuItemView from "../MenuItem/MenuItem";
import type { MenuItem } from "../types";

import type { OptionsMenuDropdownBaseProps } from "./OptionsMenuDropdown";
import OptionsMenuDropdown from "./OptionsMenuDropdown";

export type OptionsMenuProps = OptionsMenuDropdownBaseProps & {
    items: readonly MenuItem[];
    disabledTooltipContent?: string;
    children?: ReactElement;
};

const OptionsMenu = ({ items, disabledTooltipContent, children, ...props }: OptionsMenuProps) => {
    const renderWithTooltip = (menuItem: ReactElement, key: MenuItem["id"]) => (
        <Tooltip
            key={key}
            content={disabledTooltipContent}
            placement="bottom"
        >
            <Box>{menuItem}</Box>
        </Tooltip>
    );

    return (
        <OptionsMenuDropdown {...props}>
            {[
                ...items.map((item) => {
                    const menuItem = (
                        <MenuItemView
                            dataAutomation={`option-${item.id}`}
                            iconName={item.iconName}
                            iconStroke={item.iconStroke}
                            id={item.id}
                            itemText={item.text}
                            key={item.id}
                            disabled={item.disabled}
                        />
                    );
                    return item.disabled ? renderWithTooltip(menuItem, item.id) : menuItem;
                }),
                ...(children ? [children] : []),
            ]}
        </OptionsMenuDropdown>
    );
};

export default OptionsMenu;
